var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "387px",
  height: "387px",
  viewBox: "0 0 387 387",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  stroke: "#000000",
  fill: "#000000",
  points: "193.5 2 385 198 2 198"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 1,
  y: 1,
  width: 385,
  height: 385
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wind-arrow.33cc7afa69faedc349180a2320f0725f.svg";